<template>
  <div style="height: 100vh; min-height: 400px">
    <router-view />
  </div>
</template>
